import moment from 'moment';

import { URL_DATE_FORMAT } from './dateUtil';

interface Dates {
  in: string;
  out: string;
}

export function findMatchingDateFields(dates: Dates): string[] {
  const today = moment();
  const tomorrow = moment().add(1, 'days');

  const formattedToday = today.format(URL_DATE_FORMAT);
  const formattedTomorrow = tomorrow.format(URL_DATE_FORMAT);

  const matchingFields: string[] = [];

  if (dates.in === formattedToday || dates.in === formattedTomorrow) {
    matchingFields.push('in');
  }

  if (dates.out === formattedToday || dates.out === formattedTomorrow) {
    matchingFields.push('out');
  }

  return matchingFields;
}
